export default __webpack_public_path__ + "static/media/customer.f58b008f.svg";